import type { Category } from "@/types/movie";

export const categories: Category[] = [
  {
    key: "action",
    name: "动作",
    icon: "ri-sword-line",
    desc: "爆破、追车、近身格斗一应俱全，聚焦肾上腺素飙升的硬核动作大片。",
  },
  {
    key: "drama",
    name: "剧情",
    icon: "ri-book-open-line",
    desc: "以人物命运与情感为核心，展现时代与个体交织的深度叙事电影。",
  },
  {
    key: "scifi",
    name: "科幻",
    icon: "ri-planet-line",
    desc: "穿越星际与未来科技，用想象力探讨时间、宇宙与人性的边界。",
  },
  {
    key: "comedy",
    name: "喜剧",
    icon: "ri-emotion-laugh-line",
    desc: "笑点密集、节奏明快的轻松佳作，适合全家放松与解压观看。",
  },
  {
    key: "romance",
    name: "爱情",
    icon: "ri-heart-3-line",
    desc: "关于相遇、错过与重逢的细腻爱情故事，温暖而令人回味。",
  },
  {
    key: "thriller",
    name: "悬疑",
    icon: "ri-spy-line",
    desc: "层层反转与心理博弈，带你一步步走进迷雾重重的真相。",
  },
  {
    key: "animation",
    name: "动画",
    icon: "ri-brush-line",
    desc: "手绘与三维交织的视觉奇观，适合全年龄观看的治愈与冒险之旅。",
  },
  {
    key: "documentary",
    name: "纪录",
    icon: "ri-camera-lens-line",
    desc: "记录真实世界的人与自然，用镜头呈现值得被看见的故事。",
  },
];